function Banner() {
  return (
    <div className="relative">
      <div
        className="relative h-[70vh] sm:h-[88vh] min-h-[480px] flex items-end bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1529511582893-2d7e684dd128?auto=format&fit=crop&w=1800&q=80)",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/25 to-ink/10" />

        <div className="relative max-w-6xl mx-auto px-6 sm:px-8 pb-16 sm:pb-24 w-full">
          <p className="uppercase tracking-[0.2em] text-grain text-xs font-semibold mb-4">
            Functional · Instant · Green · Healthy · Nutritious
          </p>
          <h1 className="font-display text-canvas text-4xl sm:text-6xl md:text-7xl leading-[0.95] max-w-2xl">
            FIGHN AFRICA
          </h1>
          <p className="text-canvas/90 italic text-lg max-w-lg mt-5">
            "A daily meal for sustainable human and environmental wellness."
          </p>
        </div>
      </div>

      <svg
        viewBox="0 0 1440 60"
        className="w-full h-[40px] sm:h-[50px] text-canvas -mb-px"
        preserveAspectRatio="none"
      >
        <path
          fill="currentColor"
          d="M0,32L80,26.7C160,21,320,11,480,16C640,21,800,43,960,48C1120,53,1280,43,1360,37.3L1440,32L1440,60L0,60Z"
        />
      </svg>
    </div>
  );
}

export default Banner;